import { arrayOf, bool, func, instanceOf, shape, string } from 'prop-types'
import React, { useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { CustomCalendarContainer } from './CustomCalendarContainer'
import './DatePickerInput.less'
import { DEFAULT_DATE_FORMAT } from './DatePickerUtils'

const DatePickerInput = ({
  minDate,
  maxDate,
  id,
  placeholder = 'Date',
  className = '',
  onChange,
  onSelect,
  onFocus,
  date,
  displayFormat = DEFAULT_DATE_FORMAT,
  withPortal,
  showClearDate,
  renderCustomInput,
  calendarMessage,
  selectsRange,
  startDate,
  selectsStart,
  selectsEnd,
  endDate,
  inline,
  onOpen,
  onClose,
  shouldCloseOnSelect,
  allowSameDay,
  showIcon,
  excludeDates,
  highlightDates,
  renderDayContents,
}) => {
  const [isOpen, setOpen] = useState(false)

  const onCalendarOpen = () => {
    setOpen(true)

    onOpen?.()
  }

  const onCalendarClose = () => {
    setOpen(false)

    onClose?.()
  }

  return (
    <DatePicker
      shouldCloseOnSelect={shouldCloseOnSelect}
      inline={inline}
      showIcon={showIcon}
      selectsRange={selectsRange}
      selectsStart={selectsStart}
      selectsEnd={selectsEnd}
      placeholderText={placeholder || displayFormat}
      className={`ra-date-picker ${className}`}
      renderDayContents={renderDayContents}
      calendarContainer={(props) => (
        <CustomCalendarContainer
          {...props}
          message={calendarMessage}
          fullScreen={withPortal}
        />
      )}
      allowSameDay={allowSameDay}
      withPortal={withPortal}
      isClearable={showClearDate}
      onCalendarOpen={onCalendarOpen}
      onCalendarClose={onCalendarClose}
      id={id}
      dateFormat={displayFormat}
      customInput={renderCustomInput?.({
        isOpen,
        showIcon,
      })}
      selected={date}
      onSelect={onSelect}
      onChange={onChange}
      minDate={minDate}
      maxDate={maxDate}
      onFocus={onFocus}
      startDate={startDate}
      endDate={endDate}
      excludeDates={excludeDates}
      highlightDates={highlightDates}
    />
  )
}

DatePickerInput.propTypes = {
  selectsRange: bool,
  allowSameDay: bool,
  showIcon: bool,
  renderCustomInput: func,
  className: string,
  date: instanceOf(Date),
  startDate: instanceOf(Date),
  endDate: instanceOf(Date),
  onChange: func,
  onSelect: func,
  onBlur: func,
  onFocus: func,
  minDate: instanceOf(Date),
  maxDate: instanceOf(Date),
  id: string.isRequired,
  placeholder: string,
  shouldCloseOnSelect: bool,
  disabled: bool,
  required: bool,
  readOnly: bool,
  selectsStart: bool,
  selectsEnd: bool,
  showClearDate: bool,
  displayFormat: string,
  calendarMessage: string,
  onOpen: func,
  onClose: func,
  withPortal: bool,
  inline: bool,
  excludeDates: arrayOf(instanceOf(Date)),
  highlightDates: arrayOf(
    shape({
      [string]: arrayOf(instanceOf(Date)),
    }),
  ),
  renderDayContents: func,
}

export { DatePickerInput }
